import { EffortViewMode } from './useTeamEffort';
import styles from './TeamEffortTab.module.scss';

interface EffortLegendProps {
  mode: EffortViewMode;
}

// Etichette bin da spec: AU ≤250, 251–450, 451–650, 651–850, >850
const SRPE_LABELS = ['≤ 250', '251 – 450', '451 – 650', '651 – 850', '> 850'];
const RPE_LABELS = ['≤ 2', '2.1 – 4', '4.1 – 6', '6.1 – 8', '> 8'];

const BIN_CLASS = [styles.bin0, styles.bin1, styles.bin2, styles.bin3, styles.bin4];

/** Legenda bin heatmap + cella "dato mancante" */
export function EffortLegend({ mode }: EffortLegendProps) {
  const labels = mode === 'srpe' ? SRPE_LABELS : RPE_LABELS;
  const unit = mode === 'srpe' ? 'AU/giorno' : 'RPE medio';

  return (
    <div className={styles.legend}>
      <p className={styles.legendTitle}>Legenda ({unit})</p>
      {labels.map((label, i) => (
        <div key={label} className={styles.legendItem}>
          <span className={`${styles.legendSwatch} ${BIN_CLASS[i]}`} />
          <span className={styles.legendLabel}>{label}</span>
        </div>
      ))}
      <div className={styles.legendItem}>
        <span className={`${styles.legendSwatch} ${styles.missing}`} />
        <span className={styles.legendLabel}>Dato mancante</span>
      </div>
    </div>
  );
}
